import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate, useLocation } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import moment from "moment";
import Select from "react-select";
import PubSub from "pubsub-js";
import Main from "../layout/Main";
import Helmet from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";

const SupplierEdit = (props) => {
  let fnYear;
  const location = useLocation();
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState({});
  const [financialYearOption, setOptionFinancialYear] = useState({});

  const [trasportData, setTrasportData] = useState(location.state ? location.state : {});

 
      
  // const handleCourses = (selectedCourses) => {
  //   setSelectedCourses(selectedCourses);
    
  // };
  useEffect(() => {
    const fetchData = async () => {
      
      const fnYear = await trasportApi.fetchAllActiveFinancialYears();
  
      if (fnYear && fnYear.length) {
        let ar = [];
        //eslint-disable-next-line
        fnYear.map((item) => {
          var obj = {};
          obj.value = item.id;
          obj.label = item.name;
          ar.push(obj);
        });
        if (location?.state) {
          let acc = ar.filter((acc) => acc.value === location.state.financial_year_id);
          setSelectedFinancialYear(acc);
        }

        
        // // Check if the current year matches any option
        // const currentYear = new Date().getFullYear();
        // const defaultOption = ar.find(option => option.label === currentYear.toString());

        // if (defaultOption) {
        // setSelectedFinancialYear([defaultOption]); // Set the default selected option
        // }
        setOptionFinancialYear(ar);
      } else {
        setOptionFinancialYear([]);
      }
    };
  
    fetchData();
  }, []);
  
 
  
  const handleChange = (e) => {

    setTrasportData({...trasportData,[e.target.name]: e.target.value ,});
  //  if(e.target.name === "transporter_name"){
    // setTrasportData({
    //   ...trasportData,
    //   isactive: e.target.checked,
    // });
  //  }

  };
  
  // const checkRequiredFields = () => {
  //   if (trasportData.transporter_name  &&
  //     trasportData.contact_person  &&
  //     trasportData.address  &&
  //     trasportData.city  &&
  //     trasportData.district  &&
  //     trasportData.state  &&
  //     trasportData.country  &&
  //     trasportData.pincode  &&
  //     trasportData.bank_name  &&
  //     trasportData.bank_branch_name  &&
  //     trasportData.bank_account_number  &&
  //     trasportData.ifsc_cod  &&
  //     trasportData.micr  &&
  //     trasportData.rtgs_details  &&
  //     trasportData.financial_year_id &&
  //     trasportData.isactive ) {
  //     return false;
  //   }
  //   return true;
  // }

  console.log("Data Inserted ",trasportData)
  const handleSubmit = async (e) => {
    e.preventDefault();
   
    console.log("Data Inserted ",trasportData)

    // if (checkRequiredFields()) {
    //   setValidated(true);
    //   return;
    // }
    let result2 = {};

    if (trasportData.id) {
      result2 = await trasportApi.saveTransporters(trasportData);
      console.log("Result 2 Create time",result2)
      if (result2.success) {
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record Updated successfully' });
        navigate(`/transporters/${trasportData.id}`, { state: trasportData });
      }
    } else {
      console.log("Create Time Item =>",trasportData)
      result2 = await trasportApi.createTransporters(trasportData);
      
      if (result2.id) {
        console.log("Result 2 UPdate time",trasportData)
        PubSub.publish('RECORD_SAVED_TOAST', { title: 'Record Saved', message: 'Record Updated successfully' });
        navigate(`/transporters/${trasportData.id}`, { state: result2, });
      } else {
        PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record ERROR', message: result2.errors[0].msg });
      }
    }

  };

  const handleCancel = () => {
    if (location.state?.id) {
      navigate("/transporters/" + trasportData.id, {state: trasportData,});
    } else {
      navigate("/transporters/");
    }
  };

  const handlefinancialYear = (e) => {
    setSelectedFinancialYear(e);
    setTrasportData({ ...trasportData, financial_year_id: e.value });
  };

  return (
    <Main>
      <>
        <Helmet>
        <title>{LIST_TAB_TITLE.TrasportEdit}</title>
        </Helmet>
      </>
      <Container className="view-form">
        <Row>
          <Col></Col>
          <Col lg={8}>
            <Form
              className="mt-3"
              onSubmit={handleSubmit}
              noValidate
              validated={validated}
            >
              <Row className="view-form-header align-items-center">
                <Col lg={3}>Edit Client Master</Col>
                <Col lg={9} className="d-flex justify-content-end">
                  <Button className="btn-sm mx-2" onClick={handleSubmit}>
                    Save
                  </Button>
                  <Button
                    className="btn-sm"
                    variant="danger"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
              <Row>
              <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                    Financial Year
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Financial Year"
                      value={selectedFinancialYear}
                      onChange={handlefinancialYear}
                      options={financialYearOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Financial Year.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Is Active
                      </Form.Label>
                      <Form.Check
                        type="switch"
                        checked={trasportData.isactive ? true : false}
                        value={trasportData.isactive}
                        onClick={(e) => {
                          setTrasportData({
                            ...trasportData,
                            [e.target.name]: e.target.checked,
                          });
                        }}
                        name="isactive"
                      />
                    </Form.Group>
                  </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                       Transporter Name 
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="transporter_name"
                      placeholder="Enter Transporter Name"
                      value={trasportData.transporter_name}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Contact Person
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="contact_person"
                      placeholder="Enter Your Contact Person"
                      value={trasportData.contact_person}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Phone
                    </Form.Label>
                    <Form.Control
                      type="phone"
                      name="phone"
                      placeholder="Enter Your Phone"
                      value={trasportData.phone}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Email
                    </Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Enter Your Email"
                      value={trasportData.email}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Address
                    </Form.Label>
                    <Form.Control
                      required
                      // type="text"
                      as="textarea"
                      name="address"
                      placeholder="Enter Your Address"
                      value={trasportData.address}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>   
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      City
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="city"
                      placeholder="Enter Your City"
                      value={trasportData.city}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col> 
              </Row>
              <Row>
              
              <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      District
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="district"
                      placeholder="Enter District name"
                      value={trasportData.district}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                 <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      State
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="state"
                      placeholder="Enter State"
                      value={trasportData.state}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                     Country
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="country"
                      placeholder="Enter Country"
                      value={trasportData.country}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                     Pincode
                    </Form.Label>
                    <Form.Control
                      required
                      type="number"
                      name="pincode"
                      placeholder="Enter Pincode Number"
                      value={trasportData.pincode}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Container className="view-form mt-4">
                      <Row>
                          <Col></Col>
                              <Row className="view-form-header align-items-center">
                                <Col lg={3}>
                                  Bank Information
                                </Col>
                              </Row>
                      </Row>
                </Container>

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Bank Name
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="bank_name"
                      placeholder="Enter Bank Name"
                      value={trasportData.bank_name}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col> 

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Bank branch name
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="bank_branch_name"
                      placeholder="Enter Bank Branch Name"
                      value={trasportData.bank_branch_name}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col> 

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Bank Account Number
                    </Form.Label>
                    <Form.Control
                      // min="10" 
                      // max="13"
                      required
                      type="number"
                      name="bank_account_number"
                      placeholder="Enter Bank Account Number"
                      value={trasportData.bank_account_number}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col> 

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                     Ifsc Code
                    </Form.Label>
                    <Form.Control
                      required
                      type="text"
                      name="ifsc_code"
                      placeholder="Enter Ifsc Code"
                      value={trasportData.ifsc_code}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col> 
                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Micr
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="micr"
                      placeholder="Enter a Micr"
                      value={trasportData.micr}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col> 

                <Col lg={6}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Rtgs Detail
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="rtgs_details"
                      placeholder="Enter a Rtgs Detail"
                      value={trasportData.rtgs_details}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>  
              </Row>
              <Row></Row>
            </Form>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </Main>
  );
};
export default SupplierEdit;
